import type { PermissionId } from "@/constants/permissions.constants";
import type { RootState } from "@/store";
import { createSelector } from "@reduxjs/toolkit";

export const baseSelector = (state: RootState) => state.user;

export const userPermissionSelector = (page: PermissionId) =>
  createSelector(baseSelector, (user) => {
    return user.userAppPermissions[page]?.hasControl ?? false;
  });

export const userAppRolesSelector = (page: PermissionId) =>
  createSelector(
    baseSelector,
    (user): string[] => user.userAppPermissions[page]?.roles ?? []
  );

export const userRolesSelector = createSelector(
  baseSelector,
  (user) => user.roles
);
